export default __webpack_public_path__ + "static/media/home-seo-agency-bg-01.3122832e.jpg";